import { gql } from "@apollo/client"

export const GET_TERMINALS = gql`
  query getTerminals($channelSlug: String!, $categorySlug: String!) {
    category(slug: $categorySlug) {
      products(channel: $channelSlug, first: 100) {
        edges {
          node {
            id
            name
            metadata {
              key
              value
            }
            media {
              url
              id
            }
            description
            variants {
              id
              name
              metadata {
                key
                value
              }
              pricing {
                price {
                  currency
                  net {
                    amount
                    currency
                  }
                  tax {
                    amount
                    currency
                  }
                  gross {
                    amount
                    currency
                  }
                }
              }
            }
            category {
              name
            }
          }
        }
      }
    }
  }
`
